// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2VYrD","left":"StickyBox_left__2mIGM","right":"StickyBox_right__mQ4SG"};